module.exports = __webpack_public_path__ + "static/img/10areaB_01.865b881.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/10areaB_01.png
// module id = 1071
// module chunks = 1